import Vue from 'vue'
import BillingService from '@/services/billing'
import * as types from '../mutations'

const state = {
  customer: {},
  subscription: {}
}

const getters = {
  subscription: (state) => state.subscription,
  customer: (state) => state.customer,
  customerAddresses: (state) => state.customer.addresses || [],
  customerBusiness: (state) => state.customer.businesses?.length ? state.customer.businesses[0] : {},
  subscriptionAddress: (state) => {
    if (!state.subscription?.address_id || !state.customer?.addresses) return null
    return state.customer.addresses.find(a => a.id === state.subscription.address_id) || null
  },
  subscriptionBusiness: (state) => {
    if (!state.subscription?.business_id || !state.customer?.businesses) return null
    return state.customer.businesses.find(b => b.id === state.subscription.business_id) || null
  }
}

const actions = {

  async loadCustomer ({ commit }) {
    const res = await BillingService.loadCustomer()
    commit(types.SET_PADDLE_CUSTOMER, res)
  },

  async loadSubscription ({ commit }) {
    const res = await BillingService.getSubscription()
    commit(types.SET_PADDLE_SUBSCRIPTION, res)
  },

  async createCustomer ({ commit }, customer) {
    const res = await BillingService.createCustomer(customer)
    commit(types.SET_PADDLE_CUSTOMER_INFO, res)
    return res
  },

  async updateCustomer ({ commit }, { customer }) {
    const res = await BillingService.updateCustomer(customer)
    commit(types.SET_PADDLE_CUSTOMER_INFO, res)
    return res
  },

  async updateAddress ({ commit }, { address }) {
    try {
      const res = await BillingService.updateAddress(address)
      commit(types.SET_PADDLE_ADDRESS, res)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async updateBusiness ({ commit }, { business }) {
    try {
      const res = await BillingService.updateBusiness(business)
      commit(types.SET_PADDLE_BUSINESS, res)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async updateSubscriptionBusiness ({ commit }, { businessId }) {
    try {
      const res = await BillingService.updateSubscriptionBusiness(businessId)
      commit(types.SET_PADDLE_SUBSCRIPTION_BUSINESS, businessId)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async requestInvoice ({ commit }, { addressId, businessId, priceId, couponCode }) {
    try {
      const payload = { address_id: addressId, business_id: businessId, price_id: priceId }
      if (couponCode) {
        payload.coupon_code = couponCode
      }
      const res = await BillingService.requestInvoice(payload)
      return res
    } catch (error) {
      return Promise.reject(error)
    }
  },

  async getPricesPreview ({ commit }, options) {
    return BillingService.getUpgradePricesPreview(options)
  }

}

const mutations = {

  [types.SET_PADDLE_SUBSCRIPTION] (state, subscription) {
    state.subscription = subscription
  },

  [types.SET_PADDLE_SUBSCRIPTION_BUSINESS] (state, businessId) {
    Vue.set(state.subscription, 'business_id', businessId)
  },

  [types.SET_PADDLE_CUSTOMER_INFO] (state, customer) {
    Vue.set(state.customer, 'id', customer.id)
    Vue.set(state.customer, 'name', customer.name)
    Vue.set(state.customer, 'email', customer.email)
  },

  [types.SET_PADDLE_CUSTOMER] (state, customer) {
    state.customer = { ...customer }
  },

  [types.SET_PADDLE_ADDRESS] (state, address) {
    if (!state.customer.addresses) {
      Vue.set(state.customer, 'addresses', [])
    }

    const index = state.customer.addresses.findIndex(a => a.id === address.id)
    if (index > -1) {
      state.customer.addresses.splice(index, 1, address)
    } else {
      state.customer.addresses.push(address)
    }
  },

  [types.SET_PADDLE_BUSINESS] (state, business) {
    if (!state.customer.businesses) {
      Vue.set(state.customer, 'businesses', [])
    }

    const index = state.customer.businesses.findIndex(b => b.id === business.id)
    if (index > -1) {
      state.customer.businesses.splice(index, 1, business)
    } else {
      if (state.customer.businesses.length === 0) {
        state.customer.businesses.push(business)
      } else {
        Vue.set(state.customer.businesses, 0, business)
      }
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
